import { ClipboardIcon, CheckIcon } from "@heroicons/react/24/outline";
import { useState } from "react";

export const Home = () => {
    const [copied, setCopied] = useState(false);

    const command = "curl -sSfL se.tong.icu/launch.sh | bash";

    const handleCopy = () => {
        navigator.clipboard.writeText(command);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    };

    return (
        <div className="hero min-h-screen bg-base-200">
            <div className="hero-content text-center">
                <div className="max-w-md">
                    <h1 className="text-5xl font-bold mb-6">Shell Edit</h1>

                    <div className="grid grid-cols-2 gap-4 mb-6">
                        <div className="card bg-primary text-primary-content">
                            <div className="card-body items-center text-center">
                                <h2 className="card-title">No More Vim!</h2>
                                <p>Edit files without the learning curve</p>
                            </div>
                        </div>
                        <div className="card bg-pink-500 text-secondary-content">
                            <div className="card-body items-center text-center">
                                <h2 className="card-title">Any File</h2>
                                <p>Edit any file on any computer</p>
                            </div>
                        </div>
                        <div className="card bg-accent text-accent-content col-span-2">
                            <div className="card-body items-center text-center">
                                <h2 className="card-title">User-Friendly</h2>
                                <p>
                                    Intuitive editing w/o arcane knowledge of
                                    vim/emacs
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="card bg-base-100 shadow-xl">
                        <div className="card-body">
                            <h2 className="card-title justify-center">
                                Copy Paste this into your terminal!
                                <div className="badge badge-secondary">
                                    AMAZING
                                </div>
                            </h2>
                            <div className="form-control">
                                <label className="label">
                                    <span className="label-text">
                                        Just do it !!!
                                    </span>
                                    <span className="label-text-alt">
                                        Seriously !!!!
                                    </span>
                                </label>
                                <div className="relative">
                                    <input
                                        type="text"
                                        value={command}
                                        className="input input-bordered w-full pr-10"
                                        readOnly
                                    />
                                    <button
                                        className="absolute right-2 top-1/2 transform -translate-y-1/2 btn btn-ghost btn-sm"
                                        onClick={handleCopy}
                                    >
                                        {copied ? (
                                            <CheckIcon className="h-5 w-5 text-green-500" />
                                        ) : (
                                            <ClipboardIcon className="h-5 w-5" />
                                        )}
                                    </button>
                                </div>
                                <label className="label">
                                    <span className="label-text-alt">
                                        It just works !!
                                    </span>
                                    <span className="label-text-alt">
                                        Edit anything !!!
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
